import type { ColorTheme, SbColor } from './types';

const darkColors: Array<SbColor> = [
	'green-1',
	'green-2',
	'brown-1',
	'brown-2',
	'brown-3',
	'teal-1',
	'teal-2',
	'purple-1',
	'purple-2',
	'purple-3',
	'orange-1',
	'orange-2',
	'orange-3'
];

export function getColorTheme(color: SbColor): ColorTheme {
	if (darkColors.includes(color)) return 'dark';

	return 'light';
}
